import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = [] as OrderLeadTime[];

const slice = createSlice({
  name: '$orderLeadTimes',
  initialState,
  reducers: {
    setOrderLeadTimes(state, action: PayloadAction<OrderLeadTime[]>) {
      return action.payload;
    },
  },
});

export const { setOrderLeadTimes } = slice.actions;
export default slice.reducer;
